import { Component, Input } from '@angular/core';

interface AccountDetailsNavItem {
  labelKey: string;
  fgbDefault: string;
  icon: string;
  iconFont?: 'material-icons' | 'material-symbols-outlined';
  route?: string[];
  badgeKey?: string;
  badgeDefault?: string;
}

@Component({
  selector: 'fgb-account-nav',
  templateUrl: './account-nav.component.html',
  styleUrls: ['./account-nav.component.scss'],
})
export class AccountNavComponent {
  @Input() isProfilePage = false;

  navItems: AccountDetailsNavItem[] = [
    { labelKey: 'account.details-nav.my-details', fgbDefault: 'My details', icon: 'person', route: ['/account'] },
    { labelKey: 'account.details-nav.activity', fgbDefault: 'Activity', icon: 'history', route: ['/activity'] },
    { labelKey: 'account.details-nav.about-you', fgbDefault: 'About you', icon: 'help', route: ['/edit-questions'] },
    {
      labelKey: 'account.details-nav.membership',
      fgbDefault: 'Membership',
      icon: 'card_membership',
      iconFont: 'material-symbols-outlined',
      route: ['/membership'],
    },
    {
      labelKey: 'account.details-nav.partners',
      fgbDefault: 'Partners',
      icon: 'partner_exchange',
      iconFont: 'material-symbols-outlined',
      route: ['/partners'],
    },
    { labelKey: 'account.details-nav.send-points', fgbDefault: 'Send points', icon: 'send', route: ['/pointsmanagement'] },
    { labelKey: 'account.details-nav.payment', fgbDefault: 'Payment', icon: 'credit_card', route: ['/payment'] },
    {
      labelKey: 'account.details-nav.connected-apps',
      fgbDefault: 'Connected apps',
      icon: 'link',
      route: ['/fitness-tracker'],
    },
    { labelKey: 'account.details-nav.refer-a-friend', fgbDefault: 'Refer a Friend', icon: 'favorite', route: ['/referral'] },
    { labelKey: 'account.nav.member.network', fgbDefault: 'Member Network', icon: 'hub', route: ['/member-network'] },
    { labelKey: 'account.details-nav.representative', fgbDefault: 'My Representative', icon: 'support_agent', route: ['/representative'] },
    { labelKey: 'account.details-nav.facial-recognition', fgbDefault: 'Facial Recognition', icon: 'face', route: ['/facial-id'] },
  ];
}
